import React, { useState } from 'react'
import Breadcrumb from '../Components/Breadcrumb'
import Pagehelmet from '../Components/Pagehelmet'
import axios from 'axios';
import { useParams, useNavigate ,Link} from 'react-router-dom';

const Booknow = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  console.log(id, 'tickets')

  const headers = {
    Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
  };

  const url = `${process.env.REACT_APP_API_URL}/users/signup`

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    role: "parent", // default value
    address: "",             
    emergencyContact: "",    
    preferences: "",         
    familyMembers: [],       
    password: "",
    confirmpassword: ""
    // address
    //   :
    //   "lideta mercato",
    // confirmpassword
    //   :
    //   "C858585c$$",
    // email
    //   :
    //   "rrrrohadev2025@gmail.com",
    // emergencyContact
    //   :
    //   "wdwdwdw",
    // familyMembers
    //   :
    //   "dwdwdw",
    // firstName
    //   :
    //   "yohannes",
    // lastName
    //   :
    //   "Zemene",
    // password
    //   :
    //   "C858585c$$",
    // phone
    //   :
    //   "0991303007",
    // preferences
    //   :
    //   "wdwdw",
    // role
    //   :
    //   "parent"
  })

  console.log(formData, 'formData')

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Basic validation
    if (formData.password !== formData.confirmpassword) {
      setError("Passwords do not match");
      return;
    }

    if (!formData.email || !formData.firstName || !formData.lastName || !formData.password) {
      setError("Please fill in all required fields");
      return;
    }

    try {
      setLoading(true);

      // Prepare the data to send
      const payload = {
        ...formData,
        // Convert familyMembers from string to array if needed
        familyMembers: typeof formData.familyMembers === 'string' ?
          formData.familyMembers.split(',') :
          formData.familyMembers
      };

      // Remove confirmpassword as it's not needed in the API call
      delete payload.confirmpassword;

      const response = await axios.post(url, payload, { headers });

      if (response.data) {
        setSuccess(true);
        // Redirect or show success message
        setTimeout(() => {
          navigate('/OTP', {
            state: {  // Correct property name is 'state' not 'formData'
              formData: formData,
              registrationResponse: response.data // Include API response if needed
            }
          });
        }, 2000);
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError(err.response?.data?.message || 'An error occurred during registration');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Pagehelmet pageTitle="Sign Up" />
      <Breadcrumb title="Sign Up Now" />

      {/*--Book now Section start*/}
      <section className="ticket-booking">
        <div className="container">
          <div className="booking-form w-lg-75 m-auto px-2">
            <div className="form-title mb-4">
              <h2 className="mb-2"><span className="pink">Sign Up </span> Now</h2>
              <p>Sign Up To Get Tickets</p>
            </div>
            <div className="form-content">
              <form onSubmit={handleSubmit} className="max-w-3xl mx-auto p-4">
                {/* Error and Success Messages */}
                {error && (
                  <div className="alert alert-danger mb-4">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="alert alert-success mb-4">
                    Registration successful! Redirecting...
                  </div>
                )}

                {/* Student Information */}
                <div className="row mb-4">
                  <h6 className="text-xl font-semibold mb-3">Personal Information</h6>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="firstName" className="block mb-2">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label htmlFor="lastName" className="block mb-2">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="email" className="block mb-2">Email *</label>
                    <input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="phone" className="block mb-2">Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="role" className="block mb-2">Role</label>
                    <select
                      id="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                    >
                     
                      <option value="camper">camper</option>
                      <option value="parent">parent</option>
               
                    </select>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="address" className="block mb-2">Address</label>
                    <input
                      type="text"
                      id="address"
                      value={formData.address}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="emergencyContact" className="block mb-2">Emergency Contact</label>
                    <input
                      type="text"
                      id="emergencyContact"
                      value={formData.emergencyContact}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="preferences" className="block mb-2">Preferences</label>
                    <input
                      type="text"
                      id="preferences"
                      value={formData.preferences}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="familyMembers" className="block mb-2">Family Members (comma separated)</label>
                    <input
                      type="text"
                      id="familyMembers"
                      value={formData.familyMembers}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      placeholder="John, Jane, etc."
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="password" className="block mb-2">Password *</label>
                    <input
                      type="password"
                      id="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label htmlFor="confirmpassword" className="block mb-2">Confirm Password *</label>
                    <input
                      type="password"
                      id="confirmpassword"
                      value={formData.confirmpassword}
                      onChange={handleChange}
                      className="w-full p-3 border rounded"
                      required
                    />
                  </div>
                </div>

                <div className="text-left mt-6">
                  <button
                    className="btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Processing...' : 'Sign Up Now'}
                  </button>
                </div>
              </form>
                <Link to={`/SIGNIN/`} className="black">
                                                                                   Already Have Account SIGN In Now
                                                                                  </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Booknow